import { TYPE_HELP_CHANGE_CONTENT_HEIGHT } from '../reducers/help';

const changeHelpContentHeight = (height: number) => (
    { type: TYPE_HELP_CHANGE_CONTENT_HEIGHT, data: height }
);
export default changeHelpContentHeight;
